import React, {Fragment, useEffect, useState} from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import {useDispatch, useSelector} from "react-redux";
import {Link} from 'react-router-dom';

import {getTeams as onGetTeams} from "../../store/actions";

import {Badge, Button, Card, CardBody, Table,} from "reactstrap";

import OnCallModal from "./OnCallModal";

const Team = props => {

  const [modal1, setModal1] = useState(false);

  const [onCallService, setOnCallService] = useState();

  const dispatch = useDispatch();

  const {teams} = useSelector(state => ({
    teams: state.Team.teams
  }));

  useEffect(() => {
    dispatch(onGetTeams());
  }, [onGetTeams]);

  const toggleViewModal = serviceId => {
    setOnCallService(serviceId);
    setModal1(!modal1);
  };

  const headers = ['Id', 'Team Name', 'Mapped Services', 'Team Members', 'View Details']


  return (
    <React.Fragment>
      <OnCallModal isOpen={modal1} serviceId={onCallService} toggle={toggleViewModal}/>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">Latest Teams</div>

          <div className="table-responsive react-table">
            <Table bordered hover>
              <thead className="table-light table-nowrap">
              <tr>
                {headers.map((header, index) => (
                  <th key={index}>
                    <div className="mb-2">
                      {header}
                    </div>
                  </th>
                ))}
              </tr>
              </thead>

              <tbody>
              {teams.map((service, index) => {
                return (
                  <Fragment key={index}>
                    <tr>
                      <td>
                        <Link to="#" className="text-body fw-bold">{service.id}</Link>
                      </td>
                      <td>
                        {service.name}
                      </td>
                      <td>
                        <Badge className="font-size-11 badge-soft-success">Active</Badge>
                      </td>
                      <td>
                        {service.created_at}
                      </td>
                      <td>
                        {service.updated_at}
                      </td>
                      <td>
                        <Button
                          type="button"
                          color="primary"
                          className="btn-sm"
                          onClick={() => toggleViewModal(service.id)}
                        >
                          View Oncalls
                        </Button>
                      </td>
                    </tr>
                  </Fragment>
                );
              })}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

Team.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onGetServices: PropTypes.func,
};

export default withRouter(Team);
